import React from 'react';
import { Badge } from 'react-bootstrap';
import { modal } from '../modal/ModalEmitter';

const PartCard = ({ item }) => {
  const openRo = itemId => {
    modal.open('listEditItem', {
      action: 'edit',
      itemName: 'SMM1',
      lookupKey: itemId,
      render: 'listEditItem',
      title: `Edit Repair Order ${itemId}`,
      submitCallback: () => {},
    });
  };

  return (
    <div>
      <div>
        <Badge variant="primary">{item.customerName}</Badge>
      </div>
      <div className="card-popout" onClick={() => openRo(item.roId)}>
        <strong>{item.roId}</strong> <i className="fa-solid fa-arrow-up-right-from-square" />
      </div>
      <div className="description">{item.desc}</div>
      <div><Badge variant="light">OP {item.op}</Badge> <Badge variant="light">Qty {item.qty}</Badge></div>
      <div className="tech text-right">
        <Badge variant="success">{item.techName}</Badge>
      </div>
    </div>
  );
};

export default PartCard;
